import { useCallback, useEffect, useState } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { toast } from 'sonner'
import { gestoresService, type GestorEntradaDetail } from '@/services/gestoresService'

export function useGestorEntradaDetailPage() {
  const { entradaId } = useParams<{ entradaId: string }>()
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  const [detail, setDetail] = useState<GestorEntradaDetail | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const load = useCallback(async () => {
    if (!entradaId) return
    setLoading(true)
    setError(null)
    try {
      const data = await gestoresService.getEntrada(entradaId)
      setDetail(data)
    } catch {
      setError('Não foi possível carregar a entrada.')
      setDetail(null)
    } finally {
      setLoading(false)
    }
  }, [entradaId])

  useEffect(() => {
    void load()
  }, [load])

  const goBack = useCallback(() => {
    const back = searchParams.get('back')
    navigate(`/gestores${back ? `?${back}` : '?tab=entradas'}`)
  }, [searchParams, navigate])

  const handleUpdated = useCallback((updated: GestorEntradaDetail) => {
    setDetail(updated)
    if (updated.status === 'CONCLUIDO') {
      toast.success('Fluxo de entrada concluído')
    }
  }, [])

  return {
    detail,
    loading,
    error,
    goBack,
    handleUpdated,
    reload: load,
  }
}
